import { TitleCustom, ButtonsCustom, DrawerCustom } from 'src/components/custom';
import './Academy.sass';
import Search from 'antd/lib/input/Search';
import * as React from 'react';
import { LangContext } from 'src/hooks/context/lang';
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AddRetribution } from 'src/components/advancedRetribution/addRetribution/addRetribution';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import { Skeleton } from 'antd';
import Result from 'antd/lib/result';
import AcademyItem from './academyItem/academyItem';
import { useAcademy } from 'src/models/academy/academy';
import HappyPerson from 'src/static/public/images/GetAttachmentThumbnail.png';
import LogoCademy from 'src/static/public/images/logo-academy.png';
import { CheckOutlined } from '@ant-design/icons';
export default function Academy() {
    const { t } = useTranslation(['advancedretributiontranslations', 'academy']);
    const containerARef = useRef(null);
    const academyContext = useAcademy();
    const [data, setData] = useState<any[]>([]);
    const [eventsData, setEventsData] = useState(data ?? []);
    const [disabledSearch, setDisabledSearch] = useState<boolean>(true);
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(true);
    const restApiClient = React.useContext(RestApiClientContext);
    const language = useContext(LangContext);
    const scrollLib = require('react-scroll');
    const scroll = scrollLib.animateScroll;
    const userLang = language.GetLangContext();
    const handleSearch = (searchText) => {
        setEventsData([
            ...data?.filter((group) =>
                group?.name.toLowerCase()?.includes(searchText.toLowerCase()),
            ),
        ]);
    };
    const handleRender = () => {
        setData([]);
        restApiClient
            .getAcademyConfiguration(userLang, 1, 30000)
            .then((data) => {
                if (data && data.length > 0) {
                    setData([...data]);
                    setEventsData([...data]);
                } else {
                    setData([]);
                    setEventsData([]);
                }
            })
            .catch((reason: any) => {
                alert('Error' + reason);
                console.error(reason);
            })
            .finally(() => {
                setDisabledSearch(false);
                setLoadingSkeleton(false);
            });
    };

    useEffect(() => {
        scroll.scrollToTop();
        handleRender();
    }, []);

    return (
        <div>
            <div id="advanced-retribution-search" className="container special-mb">
                <div className="row">
                    <TitleCustom
                        level={1}
                        class="title-section"
                        text={t('advancedretributiontranslations:academy')}
                    />
                </div>

                <div className="row my-1 d-flex justify-content-between flex-row">
                    {academyContext.academyIsConfigured() ? (
                        <Search
                            disabled={disabledSearch}
                            onSearch={handleSearch}
                            className="search"
                        />
                    ) : (
                        <div />
                    )}
                    <ButtonsCustom
                        id="btn-retribution"
                        className="btn-primary"
                        type="primary"
                        class="button-agent-register-movil"
                        onClick={() => setVisibleDrawer((prevState) => !prevState)}
                        disabled={disabledSearch || !academyContext.academyIsConfigured()}
                        size={null}
                        content={t('advancedretributiontranslations:create-group')}
                    />
                </div>
            </div>
            <Skeleton active loading={loadingSkeleton}>
                <div id="advanced-retribution" className="container special-mb">
                    {data?.length > 0 && academyContext.academyIsConfigured() ? (
                        eventsData?.map((group, i) => (
                            <AcademyItem
                                data={group}
                                key={group.idAcademyGroups}
                                reload={handleRender}
                            />
                        ))
                    ) : !academyContext.academyIsConfigured() ? (
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div
                                onClick={() => {
                                    window.open('https://academy.beds2b.com/', '_blank');
                                }}
                                style={{ justifyContent: 'center', cursor: 'pointer' }}
                                className="row"
                            >
                                <div
                                    className="col-12 row "
                                    style={{
                                        width: '100%',
                                        position: 'relative',
                                        justifyContent: 'center',
                                        height: '100%',
                                    }}
                                >
                                    <div
                                        className="complete-responsive"
                                        id="containerOfAcademy"
                                        ref={containerARef}
                                        style={{
                                            bottom: '0',
                                            width: '100%',
                                            height: '90%',
                                            borderRadius: '10px',
                                            border: '1px solid gray',
                                            position: 'absolute',
                                        }}
                                    ></div>
                                    <div
                                        style={{
                                            zIndex: 2,
                                            display: 'flex',
                                            alignItems: 'end',
                                            justifyContent: 'center',
                                        }}
                                        className="col-lg-6 display-none"
                                    >
                                        <img
                                            style={{
                                                width: '100%',
                                                objectFit: 'contain',
                                                maxWidth: '505px',
                                            }}
                                            src={HappyPerson}
                                            alt=""
                                        />
                                    </div>
                                    <div
                                        className="col-lg-6 col-personalized margin-top-responsive"
                                        style={{
                                            marginTop: '100px',
                                            zIndex: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'start',
                                            marginBottom: '20px',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginBottom: '10px',
                                            }}
                                        >
                                            <img
                                                className="image-small"
                                                style={{ maxWidth: '250px', width: 'auto' }}
                                                src={LogoCademy}
                                                alt=""
                                            />
                                        </div>
                                        <h2>
                                            {t('academy:title')}{' '}
                                            <span style={{ color: 'var(--beds-to-b-color-dark)' }}>
                                                {t('academy:beds2b-academy')}
                                            </span>{' '}
                                        </h2>
                                        <p className="align-center-responsive">
                                            <em>{t('academy:question')}</em>
                                        </p>
                                        <p>
                                            {' '}
                                            <Trans
                                                i18nKey={'academy:subtitle'}
                                                components={{
                                                    strong: <strong />,
                                                }}
                                            />
                                        </p>
                                        <ul style={{ listStyle: 'none', padding: 0 }}>
                                            <li>
                                                <strong>
                                                    {' '}
                                                    <CheckOutlined
                                                        style={{
                                                            color: 'var(--beds-to-b-color-dark)',
                                                        }}
                                                    />{' '}
                                                    {t('academy:point1')}
                                                </strong>
                                            </li>
                                            <li>
                                                <strong>
                                                    <CheckOutlined
                                                        style={{
                                                            color: 'var(--beds-to-b-color-dark)',
                                                        }}
                                                    />{' '}
                                                    {t('academy:point2')}
                                                </strong>
                                            </li>
                                            <li>
                                                <strong>
                                                    <CheckOutlined
                                                        style={{
                                                            color: 'var(--beds-to-b-color-dark)',
                                                        }}
                                                    />{' '}
                                                    {t('academy:point3')}
                                                </strong>
                                            </li>
                                            <li>
                                                <strong>
                                                    <CheckOutlined
                                                        style={{
                                                            color: 'var(--beds-to-b-color-dark)',
                                                        }}
                                                    />{' '}
                                                    {t('academy:point4')}
                                                </strong>
                                            </li>
                                        </ul>
                                        <p>{t('academy:point-extra')}</p>
                                        <div
                                            style={{
                                                border: '1px solid var(--beds-to-b-color-green)',
                                                padding: '10px',
                                                borderRadius: '5px',
                                                width: '100%',
                                            }}
                                        >
                                            <p
                                                className="align-center-responsive"
                                                style={{ margin: 0 }}
                                            >
                                                <strong>{t('academy:info-active-academy')}</strong>
                                            </p>
                                            <p
                                                className="align-center-responsive"
                                                style={{ margin: 0 }}
                                            >
                                                {t('academy:info-connect-academy')}
                                            </p>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: 'var(--beds-to-b-color-dark)',
                                                    padding: '15px',
                                                    borderRadius: '5px',
                                                    color: 'white',
                                                    width: 'fit-content',
                                                    textAlign: 'center',
                                                    marginTop: '10px',
                                                }}
                                            >
                                                <p
                                                    className="align-center-responsive"
                                                    style={{ margin: 0 }}
                                                >
                                                    {' '}
                                                    <Trans
                                                        i18nKey="academy:more-info-active-academy"
                                                        components={{ strong: <strong /> }}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="button-container box w-100 d-flex justify-content-center align-items-center">
                                <Result
                                    title={t('advancedretributiontranslations:no-records-academy')}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <DrawerCustom
                    title={
                        <header className="d-flex justify-content-between align-items-center">
                            <span className="d-block">
                                {t(`advancedretributiontranslations:create-group`)}
                            </span>
                        </header>
                    }
                    visible={visibleDrawer}
                    setVisible={setVisibleDrawer}
                    width={320}
                    placement="right"
                    closable={true}
                    onClose={() => setVisibleDrawer(false)}
                    content={
                        <AddRetribution
                            setVisible={setVisibleDrawer}
                            retributionType="academy"
                            reload={handleRender}
                        />
                    }
                />
            </Skeleton>
        </div>
    );
}
